import React from "react"
import ReactDOM from "react-dom"
import NewsContent from "./news-content-component"

export default class NewsContentModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    this.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<NewsContent {...self.modelJson} />, self.elem)
  }
}
